// benefitTypeAction.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../../config/payrollApiConfig';
import {CreateEsicBenefitTypePayload,UpdateEsicBenefitTypePayload} from './BenefitType';

// Create
export const createEsicBenefitType = createAsyncThunk(
  'esicBenefitType/create',
  async (data: CreateEsicBenefitTypePayload, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.post('/esic-benefit-type', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create ESIC benefit type');
    }
  }
);

// Fetch All
export const fetchEsicBenefitTypeList = createAsyncThunk(
  'esicBenefitType/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get('/esic-benefit-type');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch ESIC benefit types');
    }
  }
);

// Fetch By ID
export const fetchEsicBenefitTypeById = createAsyncThunk(
  'esicBenefitType/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get(`/esic-benefit-type/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch ESIC benefit type');
    }
  }
);

// Update
export const updateEsicBenefitType = createAsyncThunk(
  'esicBenefitType/update',
  async (
    { id, ...data }: UpdateEsicBenefitTypePayload & { id: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await payrollServiceApiInstance.put(`/esic-benefit-type/${id}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update ESIC benefit type');
    }
  }
);

// Delete
export const deleteEsicBenefitType = createAsyncThunk(
  'esicBenefitType/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.delete(`/esic-benefit-type/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete ESIC benefit type');
    }
  }
);
